import { FunctionComponent, MouseEventHandler } from 'react'
import getUrl from 'libraries/front-end-core/core/url'
import cx from 'classnames'
import selectController from 'redux/selectors/selectController'
import { useSelector } from 'react-redux'
import { SEARCH } from 'constants/controllers'
import selectFlavour from 'redux/selectors/selectFlavour'
import FiberNewIcon from '@mui/icons-material/FiberNew'
import selectSearchType from 'redux/selectors/selectSearchType'

const MenuLink: FunctionComponent<MenuLinkProps> = ({
  title,
  target: _target,
  url,
  params,
  onClick,
  isNew = false,
  highlightPages = [],
  searchType,
  externalLink,
  noFlavour
}) => {
  const flavour = useSelector(selectFlavour)
  const controller = useSelector(selectController)
  const currentSearchType = useSelector(selectSearchType)

  const href = (url !== undefined && url !== '')
    ? url
    : getUrl(
      _target,
      noFlavour === true ? { ...params } : { flavour, ...params }
    )

  let active

  if (controller === SEARCH) {
    active = searchType === currentSearchType
  } else {
    active = highlightPages.includes(controller)
  }

  const className = cx(
    'no-underline nowrap f4 fw6 grow-0 shrink-0',
    'focus-outline-0 mr4 bb-medium b--transparent',
    'flex items-center black hover-slate-grey',
    { 'light-slate-grey': active }
  )

  const target = externalLink === true ? '_blank' : '_self'

  return (
    <a
      {...{ href, className, onClick, target }}
      tabIndex={-1}
      data-event-category='Main Menu'
      data-event-action='Select'
      data-event-label={title}
    >
      <div className='pr5'>
        {title}
        <span style={{ opacity: active ? 1 : 0, transition: 'opacity 0.2s' }}>_</span>
      </div>
      {isNew && <FiberNewIcon fontSize='small' />}
    </a>
  )
}

interface MenuLinkProps {
  title: string
  target?: string
  url?: string
  params?: any
  onClick: MouseEventHandler<HTMLAnchorElement>
  activeClass?: string
  isNew?: boolean
  highlightPages?: string[]
  searchType?: string
  externalLink?: boolean
  noFlavour?: boolean
}

export default MenuLink
